import React, { useEffect, useState } from 'react';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Handle scroll to change nav background
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    // Smooth scroll behavior for navigation links
    const links = document.querySelectorAll('.scroll');
    
    const handleClick = (e) => {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        const navHeight = 80;
        const targetPosition = targetElement.offsetTop - navHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        // Close mobile menu after clicking
        setMobileMenuOpen(false);
        document.body.classList.remove('menu-open');
      }
    };

    links.forEach(link => {
      link.addEventListener('click', handleClick);
    });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      links.forEach(link => {
        link.removeEventListener('click', handleClick);
      });
    };
  }, []);

  const toggleMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (!mobileMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  };

  return (
    <nav 
      id="menu-wrap" 
      className={`menu-back cbp-af-header ${scrolled ? 'cbp-af-header-shrink' : ''}`}
    >
      <div className="container">
        <div className="sixteen columns">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: scrolled ? '#606060' : '#fff',
            fontSize: 'clamp(10px, 1.2vw, 11px)',
            fontWeight: '700',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            transition: 'all 0.3s ease',
            fontFamily: 'inherit',
            marginRight: 'clamp(10px, 3vw, 40px)'
          }}>
            <svg 
              width="18" 
              height="18" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke={scrolled ? '#d4af37' : '#fff'}
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              style={{ minWidth: '18px', transition: 'stroke 0.3s ease', flexShrink: 0 }}
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <a 
              href="mailto:info@themidnightedits.com"
              className="nav-email-text"
              style={{
                color: 'inherit',
                textDecoration: 'none',
                transition: 'color 0.3s ease',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
              onMouseLeave={(e) => e.currentTarget.style.color = scrolled ? '#606060' : '#fff'}
            >
              info@themidnightedits.com
            </a>
          </div>
          
          {/* Hamburger Icon */}
          <button
            className="mobile-menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle menu"
            style={{
              display: 'none',
              position: 'relative',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '8px',
              zIndex: 1001,
              width: '44px',
              height: '44px',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px',
              flexShrink: 0
            }}
          >
            <span style={{
              width: '28px',
              height: '3px',
              background: '#d4af37',
              borderRadius: '2px',
              transition: 'all 0.3s ease',
              transform: mobileMenuOpen ? 'rotate(45deg) translateY(8px)' : 'none'
            }}></span>
            <span style={{
              width: '28px',
              height: '3px',
              background: '#d4af37',
              borderRadius: '2px',
              transition: 'all 0.3s ease',
              opacity: mobileMenuOpen ? 0 : 1
            }}></span>
            <span style={{
              width: '28px',
              height: '3px',
              background: '#d4af37',
              borderRadius: '2px',
              transition: 'all 0.3s ease',
              transform: mobileMenuOpen ? 'rotate(-45deg) translateY(-8px)' : 'none'
            }}></span>
          </button>

          <ul className={`slimmenu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <li><a className="scroll" href="#home">home</a></li>
            <li><a className="scroll" href="#about">about</a></li>
            <li><a className="scroll" href="#work">work</a></li>
            <li><a className="scroll" href="#blog">blog</a></li>
            <li><a className="scroll" href="#services">services</a></li>
            <li><a className="scroll" href="#project-registration">project registration</a></li>
            <li><a className="scroll" href="#contact">contact</a></li>
          </ul>
        </div>
      </div>

      {/* Overlay */}
      {mobileMenuOpen && (
        <div
          onClick={toggleMenu}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 998
          }}
        />
      )}
    </nav>
  );
};

export default Navigation;
